import React from 'react';
import './NotFoundPage.scss';

export default function NotFoundPage() {
  return (
    <div className="vg-container">
      <div className="wy-content">
        <h1>404</h1>
        <p>
          I know that you came here expecting something,<br />but all I can offer for you right now is...
        </p>
        <iframe
          src="https://giphy.com/embed/d7fTn7iSd2ivS"
          width="480"
          height="379"
          frameBorder="0"
          className="giphy-embed"
          allowFullScreen
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ecosystems/NotFoundPage/NotFoundPage.jsx